import React from "react";
import { CreditCard } from "lucide-react";

/**
 * Small neutral tag marking a cashless ticket or card that received at least
 * one recharge paid by bank card.
 * @returns The tag element.
 */
export const CardRechargeTag: React.FC = () => {
  return (
    <span className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
      <CreditCard className="h-3 w-3 shrink-0" />
      Recarga con tarjeta
    </span>
  );
};
